import TransactionsModule from "./store";
import store from "@/store";

export default [
  {
    path: "/transactions",
    redirect: "/transactions/mediation-requests",
    beforeEnter(to, _, next) {
      if (!store.hasModule("Transactions"))
        store.registerModule("Transactions", TransactionsModule);
      next();
    },
    component: () => import("./moduleLayout.vue"),
    children: [
      {
        path: "mediation-requests",
        name: "mediation-requests",
        component: () => import("./pages/mediation-requests/index.vue"),
        meta: {
          pageTitle: "معاملات التوسّط",
          slug: "mediation_request",
          instructionsSlug: "QR_verification",

          breadcrumb: [
            {
              text: "المعاملات",
              active: true,
            },
            {
              text: "معاملات التوسّط",
              active: true,
            },
          ],
        },
      },
      {
        path: "transactions",
        name: "transactions",
        component: () => import("./pages/transactions/index.vue"),
        meta: {
          pageTitle: "طلبات المعاملات",
          slug: "ngo_transaction_requests",
          instructionsSlug: "QR_verification",

          breadcrumb: [
            {
              text: "المعاملات",
              active: true,
            },
            {
              text: "طلبات المعاملات",
              active: true,
            },
          ],
        },
      },
      {
        path: "transactions/:id",
        name: "transactions-show",
        component: () => import("./pages/transactions/showTransaction.vue"),
        meta: {
          pageTitle: "تفاصيل معاملة",
          slug: "mediation_request",
          instructionsSlug: "QR_verification",

          breadcrumb: [
            {
              text: "طلبات المعاملات",
              active: true,
            },
            {
              text: "تفاصيل معاملة",
              active: true,
            },
          ],
        },
      },
      {
        path: "qr-scan-log/:id",
        name: "qr-scan-log",
        component: () => import("./pages/qr-scan-log/index.vue"),
        props: true,
        meta: {
          pageTitle: "سجل عمليات مسح رمز QR",
          slug: "mediation_request",
          instructionsSlug: "QR_verification",

          breadcrumb: [
            {
              text: "المعاملات",
              active: true,
            },
            {
              text: "سجل عمليات مسح رمز QR",
              active: true,
            },
          ],
        },
      },
    ],
  },
];
